import React from 'react'

import { Link } from 'react-router-dom'

import Sidebar from 'grommet/components/Sidebar'
import Header from 'grommet/components/Header'
import Box from 'grommet/components/Box'
import Menu from 'grommet/components/Menu'
import DashboardIcon from 'grommet/components/icons/base/Dashboard'
import CustomerIcon from 'grommet/components/icons/base/User'

const round = {
  borderRadius: '40px',
  marginTop: '15px',
}

export default () => (
  <Sidebar size='xsmall' align='center' style={{height: '100vh', width: '75px'}}>
    <Header pad='medium' justify='between'>
    <svg width="29px" height="24px" viewBox="0 0 29 24" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Dasboard-Copy-9" transform="translate(-26.000000, -46.000000)" fill="#009DFF">
                <g id="Group-3" transform="translate(25.869727, 45.958739)">
                    <g id="Group-3-Copy-3" transform="translate(0.168009, 0.075532)">
                        <g id="Group-2">
                            <ellipse id="Oval-Copy" cx="1.77872913" cy="10.9225586" rx="1.65967796" ry="1.59693498"></ellipse>
                            <ellipse id="Oval-Copy-3" cx="5.13722649" cy="15.1860316" rx="2.13387167" ry="2.05320212"></ellipse>
                            <g id="Group" transform="translate(16.675755, 12.000000) scale(-1, 1) translate(-16.675755, -12.000000) translate(5.175755, 0.000000)">
                                <ellipse id="Oval" cx="5.71988604" cy="5.60694887" rx="5.67929668" ry="5.46459479"></ellipse>
                                <ellipse id="Oval-Copy" cx="13.9096773" cy="14.1198569" rx="4.25947251" ry="4.09844609"></ellipse>
                                <path d="M19.8436377,22.0932076 C20.8087807,22.0932076 21.5815106,21.3496903 21.5815106,20.4449675 C21.5815106,19.5402448 20.8087807,18.7967275 19.8436377,18.7967275 C18.8784946,18.7967275 18.1057648,19.5402448 18.1057648,20.4449675 C18.1057648,21.3496903 18.8784946,22.0932076 19.8436377,22.0932076 Z M19.8436377,23.3593988 C18.1898812,23.3593988 16.8395735,22.0601386 16.8395735,20.4449675 C16.8395735,18.8297965 18.1898812,17.5305362 19.8436377,17.5305362 C21.4973941,17.5305362 22.8477018,18.8297965 22.8477018,20.4449675 C22.8477018,22.0601386 21.4973941,23.3593988 19.8436377,23.3593988 Z" id="Oval-Copy-2" fillRule="nonzero"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    </Header>
    <Box flex='grow'
      justify='start'>
      <Menu primary={true}>
        <Box style={round}>
          <Link to="/app/dashboard"><DashboardIcon style={{width: '18px'}}/></Link>
        </Box>
        <Box style={round}>
          <Link to="/app/customers"><CustomerIcon style={{width: '18px'}}/></Link>
        </Box>
      </Menu>
    </Box>
  </Sidebar>
)



// WEBPACK FOOTER //
// ./src/components/Sidebar.js